/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateAccountTransactionRequest
 */
export interface CreateAccountTransactionRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAccountTransactionRequest
     */
    'transactionType'?: CreateAccountTransactionRequestTransactionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountTransactionRequest
     */
    'operationType'?: CreateAccountTransactionRequestOperationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountTransactionRequest
     */
    'paymentType'?: CreateAccountTransactionRequestPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountTransactionRequest
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountTransactionRequest
     */
    'description'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateAccountTransactionRequest
     */
    'amount'?: number;
}

export const CreateAccountTransactionRequestTransactionTypeEnum = {
    BalanceTransfer: 'BALANCE_TRANSFER',
    DeliveryFee: 'DELIVERY_FEE',
    Discount: 'DISCOUNT',
    ManualAdjustment: 'MANUAL_ADJUSTMENT',
    MealCharge: 'MEAL_CHARGE',
    PlanSale: 'PLAN_SALE',
    PlatformFee: 'PLATFORM_FEE',
    Refund: 'REFUND',
    RefundToCreditCard: 'REFUND_TO_CREDIT_CARD',
    Consultation: 'CONSULTATION',
    InBodyAnalysis: 'IN_BODY_ANALYSIS',
    Promotion: 'PROMOTION',
    PromotionExpiry: 'PROMOTION_EXPIRY'
} as const;

export type CreateAccountTransactionRequestTransactionTypeEnum = typeof CreateAccountTransactionRequestTransactionTypeEnum[keyof typeof CreateAccountTransactionRequestTransactionTypeEnum];
export const CreateAccountTransactionRequestOperationTypeEnum = {
    Withdraw: 'WITHDRAW',
    Deposit: 'DEPOSIT'
} as const;

export type CreateAccountTransactionRequestOperationTypeEnum = typeof CreateAccountTransactionRequestOperationTypeEnum[keyof typeof CreateAccountTransactionRequestOperationTypeEnum];
export const CreateAccountTransactionRequestPaymentTypeEnum = {
    BankTransfer: 'BANK_TRANSFER',
    Cash: 'CASH',
    CreditCard: 'CREDIT_CARD',
    PaymentProvider: 'PAYMENT_PROVIDER',
    Other: 'OTHER'
} as const;

export type CreateAccountTransactionRequestPaymentTypeEnum = typeof CreateAccountTransactionRequestPaymentTypeEnum[keyof typeof CreateAccountTransactionRequestPaymentTypeEnum];


